rjm.ui.ChartBuilderCohortTimeOptionsAllView = Backbone.View.extend(
  initialize: (options) ->
    if not options or not options.cohortDescriptor
      throw "InvalidConstructorArgs - ChartBuilderCohortTimeOptionsSpecificView"

    _.bindAll this, "save", "setCohortList", "block", "unblock", "generateTemplateData", "render"
    @cohortDescriptor = options.cohortDescriptor
    @cohortList = null
    
  save: (e) ->
    @cohortDescriptor.set 
      startTime: moment.unix(@$("#cohortStartTimestamp").select2("data").id).format("YYYY-MM-DD 00:00:00")
      type: rjm.app.enums.cohortDescriptorType.ALL
      includeCurrentPeriod: @$("#currentPeriodCheckbox").is(":checked")
    ,
      silent: true
   
    return

  setCohortList: (cohortList) ->
    @cohortList = cohortList

  block: ->
    @$el.addClass "blocked loading"

  unblock: ->
    @$el.removeClass "blocked loading message"

  generateTemplateData: ->
    cohortList: @cohortList
    noTimeData: @cohortList is -1
    includeCurrentPeriod: @cohortDescriptor.get("includeCurrentPeriod")

  render: ->
    $(@el).html ich.chartBuilderCohortTimeOptionsAll(@generateTemplateData())
    
    @$("#cohortStartTimestamp").select2
      width: "resolve"

    @$("#currentPeriod").toggleButtons
      width: 75
      height: 20
      label:
        enabled: "Yes"
        disabled: "No"
      style:
        enabled: "success"
        disabled: "danger"
    
    if(@cohortDescriptor.get("startTime")?)
      startTimestamp = @cohortDescriptor.cleanMoment(moment(@cohortDescriptor.get('startTime'))).valueOf()/1000
      @$("#cohortStartTimestamp").select2("val", startTimestamp)

    if @cohortList?
      @unblock()
    else
      @block()

    return @
)
